import React from 'react';
import { connect } from 'react-redux';
import QuotationForm from '../../../Components/CasallPro/Quotation/QuotationForm';
import {
    setErrorState,
    setTermsAcceptState,
    setSubmitState,
    updateFormDetails,
    updateResponse
} from '../../../Actions/Quotation.action';

const QuotationFormContainer = props => (
    <QuotationForm {...{
        ...props
    }} ></QuotationForm>
);

const mapStateToProps = state => {
    const { quotation } = state;
    return {
        ...quotation,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateFormDetails: formDetails => dispatch(updateFormDetails(formDetails)),
        updateResponse: (payload) => dispatch(updateResponse(payload)),
        setErrorState: (errors) => dispatch(setErrorState(errors)),
        setTermsAcceptState: (state) => dispatch(setTermsAcceptState(state)),
        setSubmitState: (state) => dispatch(setSubmitState(state)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(QuotationFormContainer);